import { render, staticRenderFns } from "./addFunction.vue?vue&type=template&id=79936344&scoped=true"
import script from "./addFunction.vue?vue&type=script&lang=js"
export * from "./addFunction.vue?vue&type=script&lang=js"
import style0 from "./addFunction.vue?vue&type=style&index=0&id=79936344&style=scss&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79936344",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79936344')) {
      api.createRecord('79936344', component.options)
    } else {
      api.reload('79936344', component.options)
    }
    module.hot.accept("./addFunction.vue?vue&type=template&id=79936344&scoped=true", function () {
      api.rerender('79936344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/componentFunction/addFunction.vue"
export default component.exports